import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import { PATH } from '../../constants/router'
import { buildQueryString, decodeLink, getUrlParamValue } from '../../helper/params'

export default function TrafficFineRedirectHandler() {
  const history = useHistory()

  useEffect(() => {
    const rawRedirectData = getUrlParamValue('redirectData')

    if (!rawRedirectData) {
      history.replace(PATH.TRAFFIC_FINE_SERVICES)
      return
    }

    try {
      const redirectData = JSON.parse(decodeLink(rawRedirectData))
      const redirectUrl = redirectData?.redirectUrl || PATH.TRAFFIC_FINE_SERVICES
      const queryString = buildQueryString(redirectData?.params || {})

      history.replace(`${redirectUrl}${queryString}`)
    } catch (error) {
      console.error(error)
      history.replace(PATH.TRAFFIC_FINE_SERVICES)
    }
  }, [history])

  return <LoadingScreen open />
}